import script from "./HelpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpPage.vue?vue&type=script&setup=true&lang=js"

import "./HelpPage.vue?vue&type=style&index=0&id=7743ecc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7743ecc3"]])

export default __exports__